var listeners = new Map()
var directListeners = {}
var hasRegistered = false

function register() {
  hasRegistered = true
  window.addEventListener('keypress', (event) => {
    var which = event.which
    var c = String.fromCharCode(which)

    ;(directListeners[which] || []).forEach(cb => cb())

    if('1234567890'.includes(c)) {
      listen.n += c
      return
    }
    listeners.forEach((cb, keys) => {
      if(keys.includes(c)) {
        event.preventDefault()
        cb(c, listen.n)
      }
    })
    listen.n = ''
  })
}

function listen(shortcuts, cb) {
  if(!hasRegistered) register()
  listeners.set(shortcuts, cb)
  return function cancel() {
    listeners.delete(shortcuts)
  }
}

listen.direct = function direct(keyCode, cb) {
  if(!hasRegistered) register()
  directListeners[keyCode] || (directListeners[keyCode] = [])
  directListeners[keyCode].push(cb)
  return function cancel() {
    var arr = directListeners[keyCode]
    var i = arr.indexOf(cb)
    if(i < 0) return
    arr[i] = arr[arr.length - 1]
    arr.pop()
  }
}

listen.n = ''

export default listen
